import { RouteState } from "../../entity/enums";
import { RouteBGColor } from "../../models/core";

export class KPIRouteStateColor {
    static getRouteStatusColor(routeStatus:string) {
        const routeState = routeStatus.toLowerCase();
        let TaskStateColor = "";
        switch (routeState) {
            case RouteState.Planning:
                TaskStateColor = RouteBGColor.Planning;
                break;
            case RouteState.Loading:
                TaskStateColor = RouteBGColor.Loading;
                break;
            case RouteState.Sorting:
                TaskStateColor = RouteBGColor.Sorting;
                break;
            case RouteState.Onroute:
                TaskStateColor = RouteBGColor.Onroute;
                break;
            case RouteState.Finishloading:
                TaskStateColor = RouteBGColor.Finishloading;
                break;
            case RouteState.Prepareroute:
                TaskStateColor = RouteBGColor.PrepareRoute;
                break;
            case RouteState.Completed:
                TaskStateColor = RouteBGColor.Completed;
                break;
            default:
                TaskStateColor = '#000';
                break;
        }
        return TaskStateColor
    }
}